var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from "react";
import { DisplayV2Theme } from "../DisplayTheme";
var FooterV2BottomLinkDisplayTheme = forwardRef(function (props, ref) {
    return (React.createElement("li", { className: "fr-footer__bottom-item" },
        React.createElement(DisplayV2Theme, __assign({ ref: ref }, props))));
});
export default FooterV2BottomLinkDisplayTheme;
